import { Listbox, Dialog } from '@headlessui/react';
import React, {
  ForwardedRef,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import Next from '../assets/next.svg';
import Op from '../assets/op-new.png';
import Op2 from '../assets/op2.png';
import BG_Pad from '../assets/pad.png';
import BG_PC from '../assets/pc.png';
import Person from '../assets/person.png';
import Prev from '../assets/prev.svg';
// import Toggle from '../assets/toggle.svg';
import clsx from 'clsx';
import { debounce } from 'lodash';
import pinyin from 'pinyin';
import { Swiper as SwiperClass } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import Avatar from '../assets/avatar.png';
import Hangup from '../assets/hangup.svg';
import List from '../assets/list.svg';
import Selected from '../assets/selected.svg';
import Wallpaper from '../assets/wallpaper.png';

let _stream: MediaStream | null;

const setVideoSource = (dom: HTMLVideoElement, stream: MediaStream | null) => {
  // dom.pause();
  // dom.srcObject = null;
  dom.srcObject = stream;
  // dom.play();
};
const clearStream = (stream: MediaStream | null) => {
  if (!stream) return null;
  stream.getTracks().forEach(track => track.stop());
  return null;
};

function IndexPage() {
  const padRef = useRef<HTMLVideoElement>(null);
  const pad2Ref = useRef<HTMLVideoElement>(null);
  const pcRef = useRef<HTMLVideoElement>(null);
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [swiperIns, setSwiperIns] = useState<SwiperClass | null>(null);
  const [devices, setDevices] = useState<MediaDeviceInfo[]>([]);
  const [selected, setSelected] = useState<MediaDeviceInfo>();
  const [isScaleX, setIsScaleX] = useState(false);

  const refs = useMemo(() => [padRef, pad2Ref, pcRef], []);

  // 移动设备的前置摄像头和PC的摄像头需要进行翻转
  const shouldMirrorFlip = (device?: MediaDeviceInfo) => {
    if (!device) return false;
    const { label } = device;
    const isFrontCamera = label?.includes('前置');
    const isRearCamera = label?.includes('后置');
    const isPcCamera = !isFrontCamera && !isRearCamera;
    return isFrontCamera || isPcCamera;
  };

  const start = useCallback(
    async (device?: MediaDeviceInfo) => {
      try {
        const { deviceId, groupId } = device || {};
        if (device) {
          setSelected(device);
        }
        _stream = clearStream(_stream);

        _stream = await navigator.mediaDevices.getUserMedia({
          video: deviceId
            ? {
                deviceId,
                groupId,
                width: { min: 320, ideal: 1280, max: 1920 },
                height: { min: 240, ideal: 720, max: 1080 },
              }
            : true,
          audio: false,
        });

        const rf = refs.find((item, index) => index === activeIndex);

        if (!rf?.current) return;

        setIsScaleX(shouldMirrorFlip(device));
        setVideoSource(rf.current, _stream);
      } catch (e: any) {
        if (e?.message === 'Permission denied by system') {
          openModal();
        }
      }
    },
    [activeIndex, refs],
  );

  const getDevices = useCallback(async () => {
    const mediaDevices: MediaDeviceInfo[] =
      await navigator.mediaDevices.enumerateDevices();
    // 先过滤出视频流
    const filter = mediaDevices.filter(item => item.kind === 'videoinput');
    // 根据名称排个序
    return filter.sort((a, b) => pinyin.compare(b.label, a.label));
  }, []);

  const init = useCallback(async () => {
    await start();
    const filter = await getDevices();
    if (filter.length <= 0) return;
    const defaultDevice =
      filter.find(device => device.label.includes('前置')) || filter[0];
    await start(defaultDevice);
    setDevices(filter);
  }, [getDevices, start]);

  const handleChange = useCallback(
    (device: MediaDeviceInfo) => {
      start(device);
    },
    [start],
  );

  useEffect(() => {
    init();
    return () => {
      clearStream(_stream);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const visibilitychange = (e: any) => {
      if (document.visibilityState === 'visible' && _stream?.active === false) {
        start(selected);
      }
    };
    document.addEventListener('visibilitychange', visibilitychange);
    return () =>
      document.removeEventListener('visibilitychange', visibilitychange);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const devicechange = debounce(async (e: Event) => {
      const filter = await getDevices();
      if (filter.length <= devices.length) {
        start(filter[0]);
      }
      setDevices(filter);
    }, 300);
    navigator.mediaDevices.addEventListener('devicechange', devicechange);
    return () => {
      navigator.mediaDevices.removeEventListener('devicechange', devicechange);
    };
  }, [devices, getDevices, start]);

  const handleSwiperChange = useCallback(
    (activeIndex: number) => {
      refs.forEach((ref, index) => {
        if (!ref.current) return;
        if (index === activeIndex) {
          ref.current.srcObject = _stream;
        } else {
          ref.current.srcObject = null;
        }
      });
      setActiveIndex(activeIndex);
    },
    [refs],
  );

  const slideList = [
    <Pad ref={padRef} isScaleX={isScaleX} />,
    <Pad2 ref={pad2Ref} isScaleX={isScaleX} />,
    <PcGame ref={pcRef} isScaleX={isScaleX} />,
  ];

  // const handleFangZhuan = useCallback(() => {
  //   const current = selected;
  //   const { label, deviceId } = current || {};
  //   if (!label) return;
  //   const device = devices?.find(item => {
  //     const preStr = label.slice(0, -4);
  //     if (item.label.includes(preStr) && item.deviceId !== deviceId)
  //       return true;
  //     return false;
  //   });
  //   start(device);
  //   setSelected(device);
  //   return;
  // }, [devices, selected, start]);

  // const renderFangZhuan = useMemo(() => {
  //   const { label } = selected || {};

  //   if (!label || (!label.includes('后置') && !label.includes('前置')))
  //     return null;
  //   return (
  //     <div
  //       className="flex justify-center items-center w-[54px] h-[54px] rounded-[16px] ml-[10px] bg-[#eeeeee] cursor-pointer"
  //       onClick={handleFangZhuan}
  //     >
  //       <img src={Toggle} alt="toggle" />
  //     </div>
  //   );
  // }, [handleFangZhuan, selected]);

  const [showModal, setShowModal] = useState(false);
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  return (
    <div className="h-full flex items-center justify-center">
      <div className="block w-full">
        {/* 操作区域 */}
        <div className="flex justify-center items-center w-full mt-[15px]">
          <div className="text-[16px] font-medium mr-[10px]">选择设备</div>
          <Listbox value={selected} onChange={handleChange}>
            <div className="relative w-[288px] h-[54px] rounded-[16px] bg-[#eeeeee]">
              <Listbox.Button className="w-full h-full flex justify-between items-center px-[24px]">
                <span className="whitespace-nowrap text-ellipsis overflow-hidden ">
                  {selected?.label}
                </span>
                <img className="ml-[4px]" src={List} alt="list" />
              </Listbox.Button>
              <Listbox.Options className="overflow-hidden absolute z-10 top-[64px] w-full rounded-[16px] bg-white shadow-[0_5px_15px_0px_rgba(0,0,0,0.3)]">
                {devices &&
                  devices.map(device => (
                    <Listbox.Option
                      className={clsx(
                        'py-[12px] flex justify-between items-center px-[20px]',
                        selected?.deviceId === device.deviceId &&
                          'text-[#3482FF] bg-[#e9efff]',
                      )}
                      value={device}
                      key={device.deviceId}
                    >
                      <span className="whitespace-nowrap text-ellipsis overflow-hidden">
                        {device.label}
                      </span>
                      {selected?.deviceId === device.deviceId && (
                        <img
                          className="ml-[4px]"
                          src={Selected}
                          alt="selected"
                        ></img>
                      )}
                    </Listbox.Option>
                  ))}
              </Listbox.Options>
            </div>
          </Listbox>

          {/* {renderFangZhuan} */}
        </div>

        <Swiper
          autoplay={false}
          onSwiper={async (swiper: SwiperClass) => {
            setSwiperIns(swiper);
          }}
          onSlideChange={swiper => handleSwiperChange(swiper.activeIndex)}
        >
          {slideList.map((slide, index) => (
            <SwiperSlide key={index}>{slide}</SwiperSlide>
          ))}
        </Swiper>

        {activeIndex !== 0 && (
          <div
            id="prev"
            className="flex items-center z-10 fixed left-[68px] top-0 bottom-0"
          >
            <div
              className="cursor-pointer flex justify-center items-center w-[54px] h-[54px] bg-[#f0f0f0] rounded-full"
              onClick={() => {
                handleSwiperChange(activeIndex - 1);
                swiperIns?.slideTo(activeIndex - 1);
              }}
            >
              <img src={Prev} alt="prev" />
            </div>
          </div>
        )}
        {activeIndex !== slideList.length - 1 && (
          <div
            id="next"
            className="flex items-center z-10 fixed right-[68px] top-0 bottom-0"
          >
            <div
              className="cursor-pointer flex justify-center items-center w-[54px] h-[54px] bg-[#f0f0f0] rounded-full"
              onClick={() => {
                handleSwiperChange(activeIndex + 1);
                swiperIns?.slideTo(activeIndex + 1);
              }}
            >
              <img src={Next} alt="next" />
            </div>
          </div>
        )}
      </div>
      <Dialog open={showModal} className="relative z-10" onClose={closeModal}>
        <div className="fixed inset-0 bg-black/25" />
        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center text-center">
            <Dialog.Panel className="bg-white rounded-[32px] p-[24px]">
              <Dialog.Title className="text-[18px] font-medium">
                连接失败
              </Dialog.Title>
              <p className="text-[16px] leading-[22.4px] mt-[16px]">
                请联系店员提供连接帮助
              </p>
              <button
                className="w-[322px] mt-[24px] text-white leading-[50px] bg-[#3482FF] rounded-[16px]"
                onClick={closeModal}
              >
                好的
              </button>
            </Dialog.Panel>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default IndexPage;

const Pad = React.forwardRef(
  (props: { isScaleX: boolean }, ref: ForwardedRef<HTMLVideoElement>) => {
    const { isScaleX } = props;
    return (
      <div className="w-[896px] m-auto">
        <div className="text-center mb-[9px] mt-[24px]">
          <h1 className="text-[22px] leading-[29px] font-semibold mb-[4px]">
            线上会议场景
          </h1>
          <p className="text-[14px] leading-[18px] font-normal text-black/60">
            此界面为模拟场景不可交互，如需真实体验请联系门店导购
          </p>
        </div>

        <div
          className="h-[580px] pl-[25px] pr-[23px] pt-[26px] pb-[24px]"
          style={{
            backgroundImage: `url(${BG_Pad})`,
            backgroundSize: '100%',
          }}
        >
          <div className="w-full h-full rounded-[16px] overflow-hidden flex flex-col items-center">
            <div className="relative w-full text-center mt-[8px]">
              <p className="text-[12px]">ID: 545 926 401</p>
              <p className="text-[10px]">01:47</p>
              <img
                className="absolute right-[50px] top-0 bottom-0 margin-auto"
                src={Hangup}
                alt=""
              ></img>
            </div>
            <div className="w-[742px] h-[75px] px-auto">
              <img src={Person} alt="" />
            </div>
            <div
              className={clsx(
                'w-[742px] h-[356px] mt-[10px] px-auto overflow-hidden relative rounded-[10px] mb-[7px]',
                isScaleX ? '-scale-1 -scale-x-100' : '',
              )}
            >
              <video
                autoPlay
                className="object-cover w-full h-full absolute "
                ref={ref}
              ></video>
            </div>
            <div className="w-[400px] h-[35px] px-auto">
              <img src={Op} alt="" />
            </div>
          </div>
        </div>
      </div>
    );
  },
);

const Pad2 = React.forwardRef(
  (props: { isScaleX: boolean }, ref: ForwardedRef<HTMLVideoElement>) => {
    const { isScaleX } = props;
    return (
      <div className="w-[896px] m-auto">
        <div className="text-center mb-[9px] mt-[24px]">
          <h1 className="text-[22px] leading-[29px] font-semibold mb-[4px]">
            微信多人视频通话
          </h1>
          <p className="text-[14px] leading-[18px] font-normal text-black/60">
            此界面为模拟场景不可交互，如需真实体验请联系门店导购
          </p>
        </div>
        <div
          className="w-full h-[580px] pl-[25px] pr-[23px] pt-[26px] pb-[24px]"
          style={{
            backgroundImage: `url(${BG_Pad})`,
            backgroundSize: '100%',
          }}
        >
          <div className="w-full h-full rounded-[16px] overflow-hidden flex flex-col items-center bg-[#292929]">
            <div className="text-center text-white/50 h-[28px] leading-[28px]">
              <p className="text-[10px]">01:47</p>
            </div>
            <div className="w-full h-[443px] flex mb-[10px]">
              <div
                className={clsx(
                  'h-full overflow-hidden relative flex-grow',
                  isScaleX ? '-scale-x-100' : '',
                )}
              >
                <video
                  autoPlay
                  className="object-cover w-full h-full absolute "
                  ref={ref}
                ></video>
              </div>
              <div className="w-[81px] h-full flex items-center">
                <img src={Avatar} alt="" />
              </div>
            </div>
            <div className="w-[429px] h-[44px] px-auto">
              <img src={Op2} alt="" />
            </div>
          </div>
        </div>
      </div>
    );
  },
);

const PcGame = React.forwardRef(
  (props: { isScaleX: boolean }, ref: ForwardedRef<HTMLVideoElement>) => {
    const { isScaleX } = props;
    return (
      <div className="w-[896px] m-auto">
        <div className="text-center mb-[9px] mt-[24px]">
          <h1 className="text-[22px] leading-[29px] font-semibold mb-[4px]">
            游戏直播
          </h1>
          <p className="text-[14px] leading-[18px] font-normal text-black/60">
            此界面为模拟场景不可交互，如需真实体验请联系门店导购
          </p>
        </div>

        <div className="h-[610px] relative">
          <div
            className="absolute w-[1277px] h-[616px] left-[50%] ml-[-638px] bg-no-repeat"
            style={{
              backgroundImage: `url(${BG_PC})`,
              backgroundSize: 'auto 100%',
              backgroundPosition: '50%, 0',
            }}
          />
          <div className="w-full h-full rounded-[16px] overflow-hidden flex flex-col items-center">
            <div
              className="w-[813px] h-[508px] mt-[18px] px-auto overflow-hidden relative rounded-[10px] mb-[14px] flex justify-start items-end"
              style={{
                backgroundImage: `url(${Wallpaper})`,
                backgroundSize: '100%',
              }}
            >
              <div
                className={clsx(
                  'w-[412px] h-[232px]',
                  isScaleX ? '-scale-x-100' : '',
                )}
              >
                <video
                  autoPlay
                  className="object-cover w-full h-full"
                  ref={ref}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },
);
